import { default as BDiaryDaySearchEdiblesFormForm } from "./Profile/BDiaryDaySearchEdibles/Form"
import BChart from "./Modules/BChart"
import BCheckpanel from "../modules/BCheckpanel"
import BContentToggle from "../modules/BContentToggle"
import BDragDropUploadForm from "../modules/DragDropUpload/BDragDropUploadForm"
import BDatepicker from "./Modules/BDatepicker"
import BDialogTrigger from "../modules/BDialogTrigger"
import BDiaryDay from "./Profile/BDiaryDay"
import BDiaryDayEntries from "./Profile/BDiaryDayEntries"
import BDiaryDayEntry from "./Profile/BDiaryDayEntry"
import BDiaryDayFormGlucose from "./Profile/BDiaryDayFormGlucose"
import BDrugs from "./Profile/BDrugs"
import BDrugsForm from "./Profile/BDrugsForm"
import BFrontCaloricCalculator from "../modules/CaloricCalculator/BFrontCaloricCalculator"
import BHealthcareProviderSetupForm from "./Sales/BHealthcareProviderSetupForm"
import BInput from "../modules/BInput"
import BLightbox from "../modules/BLightbox"
import BMeasurements from "./Profile/BMeasurements"
import BMeasurementsForm from "./Profile/BMeasurementsForm"
import BMobileNav from "./Modules/BMobileNav"
import BNutriangle from "./Modules/BNutriangle"
import BModalTrigger from "../modules/BModalTrigger"
import BOAuthAuthorizeForm from "../modules/BOAuthAuthorizeForm"
import BPrintButton from "./Modules/BPrintButton"
import BFilterList from "./Modules/BFilterList"
import BRangeSlider from "./Modules/BRangeSlider"
import BRecipeFilter from "./Modules/BRecipeFilter"
import BRecipeForm from "./Modules/BRecipeForm"
import BRecipeList from "./Modules/BRecipeList"
import BRecipeSearch from "./Modules/BRecipeSearch"
import BRecipeShareForm from "./Modules/BRecipeShareForm"
import BRecipeSort from "./Modules/BRecipeSort"
import BProfileArticleFilter from "./Profile/BProfileArticleFilter"
import BProfileArticleReadStatusButtons from "./Profile/BProfileArticleReadStatusButtons"
import BProfileDiaryGlucoseReport from "./Profile/BProfileDiaryGlucoseReport"
import BProfileMessage from "./Profile/BProfileMessage"
import BPasswordRequirements from "../modules/BPasswordRequirements"
import BRecaptchaForm from "../modules/BRecaptchaForm"
import BSalesProductSetupDelegates from "./Sales/BSalesProductSetupDelegates"
import BSalesProductSetupForm from "./Sales/BSalesProductSetupForm"
import BSelect from "./Modules/BSelect"
import BShowtoggle from "../modules/BShowtoggle"
import BTabs from "../modules/BTabs"
import BUserIngredientsTable from "./Profile/BUserIngredientsTable"
import BDiaryNutrientGoalTemplateForm from "./Profile/BDiaryNutrientGoalTemplateForm"

BChart.initialize();
BCheckpanel.initialize();
BContentToggle.initialize();
BDatepicker.initialize();
BDialogTrigger.initialize();
BDiaryDay.initialize();
BDiaryDayEntries.initialize();
BDiaryDayEntry.initialize();
BDiaryDayFormGlucose.initialize();
BDiaryDaySearchEdiblesFormForm.initialize();
BDiaryNutrientGoalTemplateForm.initialize();
BDragDropUploadForm.initialize();
BDrugs.initialize();
BDrugsForm.initialize();
BFrontCaloricCalculator.initialize();
BHealthcareProviderSetupForm.initialize();
BInput.initialize();
BLightbox.initialize();
BMeasurements.initialize();
BMeasurementsForm.initialize();
BMobileNav.initialize();
BNutriangle.initialize();
BModalTrigger.initialize();
BOAuthAuthorizeForm.initialize();
BPrintButton.initialize();
BRangeSlider.initialize();
BRecipeFilter.initialize();
BRecipeForm.initialize();
BRecipeList.initialize();
BRecipeSearch.initialize();
BRecipeShareForm.initialize();
BFilterList.initialize();
BRecipeSort.initialize();
BProfileArticleFilter.initialize();
BProfileArticleReadStatusButtons.initialize();
BProfileDiaryGlucoseReport.initialize();
BProfileMessage.initialize();
BPasswordRequirements.initialize();
BRecaptchaForm.initialize();
BSalesProductSetupDelegates.initialize();
BSalesProductSetupForm.initialize();
BSelect.initialize();
BShowtoggle.initialize();
BTabs.initialize();
BUserIngredientsTable.initialize();

try {
	document.querySelector(`.focus`).focus();
} catch (error) {
	// Nevermind.
}



// Firebase Analytics — disabled until the API key is updated in the
// Firebase console. Re-enable by uncommenting and setting a valid apiKey.
// https://firebase.google.com/docs/web/setup#available-libraries
//
// const firebaseConfig = {
//   apiKey: "REPLACE_WITH_VALID_KEY",
//   authDomain: "jidelni-plan-17f76.firebaseapp.com",
//   projectId: "jidelni-plan-17f76",
//   storageBucket: "jidelni-plan-17f76.appspot.com",
//   messagingSenderId: "91184796644",
//   appId: "1:91184796644:web:4150edfd4600d2070fadf1",
//   measurementId: "G-C9WL2FWLG4",
// };
//
// const canInitFirebaseAnalytics =
//   typeof window !== "undefined" &&
//   window._config &&
//   window._config.environment === "PRODUCTION";
//
// if (canInitFirebaseAnalytics) {
//   Promise.all([import("firebase/app"), import("firebase/analytics")])
//     .then(([{ initializeApp }, { getAnalytics, isSupported }]) => {
//       const app = initializeApp(firebaseConfig);
//       return isSupported().then((supported) => {
//         if (supported) {
//           getAnalytics(app);
//         }
//       });
//     })
//     .catch(() => {});
// }
